import lottie, { type AnimationItem } from 'lottie-web';

const LOTTIE_PATH = '/Plant%20Scanning.json';

export class IntroLottie {
  private container: HTMLElement | null = null;
  private animation: AnimationItem | null = null;

  constructor() {
    this.container = document.getElementById('intro-lottie');
    if (!this.container) return;

    try {
      this.animation = lottie.loadAnimation({
        container: this.container,
        path: LOTTIE_PATH,
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });
    } catch (e) {
      console.warn('Intro Lottie failed to load:', e);
    }
  }

  dispose(): void {
    if (this.animation) {
      this.animation.destroy();
      this.animation = null;
    }
    this.container = null;
  }
}
